import React from 'react'

interface TextNumberingProps extends React.HTMLProps<HTMLDivElement>{
  number?: number | string;
  description?: string | JSX.Element;
}

function TextNumbering({...props}:TextNumberingProps) {
  return (
    <div className='polymer-text-numbering' style={{...props.style}}>
      {props.number && <div><p>{`${props.number}. `}</p></div>}
      {typeof props.description === "string" && <div>
        <p>{props.description}</p>
      </div>}
      {typeof props.description === "object" && props.description}
    </div>
  )
}

export default TextNumbering